export default __webpack_public_path__ + "assets/images/selected-card-icon.ac8db0fdd71646355fb4d8e64c854ab9.svg";